import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Container, Button } from 'react-bootstrap';
import { ArrowLeft } from 'iconoir-react';
import { getPedidoByHash, getLojaInfo } from '../services/api';
import Loading from '../components/Loading';
import PedidoDetalhesLayout from '../components/PedidoDetalhesLayout';
import LoginModal from '../components/LoginModal';
import './PedidoDetalhes.css';
import '../components/ButtonStyles.css';

function PedidoDetalhes({ brand }) {
  const { hash } = useParams();
  const navigate = useNavigate();
  const [comanda, setComanda] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [usuario, setUsuario] = useState(null);

  useEffect(() => {
    carregarPedido();
  }, [hash, brand]);

  // Verificar se usuário está logado
  useEffect(() => {
    const token = localStorage.getItem('sitri_token');
    const user = localStorage.getItem('sitri_user');
    if (token && user) {
      try {
        const userData = JSON.parse(user);
        setUsuario(userData);
      } catch (error) {
        // Erro silencioso
      }
    } else {
      setUsuario(null);
    }
  }, []);

  const carregarPedido = async () => {
    try {
      setLoading(true);
      const data = await getPedidoByHash(brand, hash);
      setComanda(data);

      // Garantir que window.lojaInfo esteja disponível
      if (!window.lojaInfo) {
        try {
          const lojaData = await getLojaInfo(brand);
          if (lojaData?.loja) {
            window.lojaInfo = lojaData.loja;
          }
        } catch (e) {
          // Erro silencioso
        }
      }
    } catch (error) {
      setError('Pedido não encontrado');
    } finally {
      setLoading(false);
    }
  };



  if (loading) {
    return <Loading message="Carregando detalhes do pedido..." />;
  }

  if (error || !comanda) {
    return (
      <Container className="py-5 text-start" style={{maxWidth: '539px'}}>
        <h4>Pedido não encontrado</h4>
        <p className="text-muted">Verifique o link e tente novamente</p>
        <Button variant="primary" onClick={() => navigate('/')}>
          Voltar ao Cardápio
        </Button>
      </Container>
    );
  }

  return (
    <div className="pedido-detalhes-page" style={{backgroundColor:'#f3f4f6', minHeight:'100vh'}}>
      {/* Header */}
      <div className="sticky-top bg-white border-bottom" style={{zIndex: 1000}}>
        <Container className="py-3" style={{maxWidth: '539px'}}>
          <div className="d-flex justify-content-between">
            <div className="d-flex">
              <Button 
                variant="outline-secondary" 
                onClick={() => navigate('/')}
                className="btn-cancel-light"
                style={{
                  padding: '8px 16px',
                  borderRadius: '12px',
                  fontSize: '0.85rem',
                  border: '1px solid #e5e7eb',
                  color: '#6b7280',
                  backgroundColor: 'white',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '6px',
                  marginRight: '12px'
                }}
              >
                <ArrowLeft width="16" height="16" />
                Voltar
              </Button>
              <h4 className="mb-0">Pedido #{comanda.id}</h4>
            </div>
            <Button 
              variant="primary" 
              size="sm"
              onClick={() => navigate('/balcao')}
            >
              Novo Pedido
            </Button>
          </div>
        </Container>
      </div>

      {/* Content */}
      <Container className="py-4" style={{maxWidth: '539px'}}>
        <PedidoDetalhesLayout 
          comandaData={comanda}
          showLoginPrompt={!usuario}
          onLoginClick={() => setShowLoginModal(true)}
        />
      </Container>

      {/* Modal de Login */}
      <LoginModal
        show={showLoginModal}
        onHide={() => setShowLoginModal(false)}
        onLogin={(userData) => {
          setUsuario(userData);
          localStorage.setItem('sitri_user', JSON.stringify(userData));
        }}
        brandLogoUrl={window.lojaInfo?.logo_url}
      />
    </div>
  );
}

export default PedidoDetalhes;